import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { hostSlice } from "./reducer/Host";
import { errorSlice, successSlice, warningSlice } from "./reducer/MessagesSlice";
import { userSlice } from "./reducer/UserSlice";
import { AnalyticApi } from "./services/AnalyticApiService";
import { AudioApi } from "./services/AudioApiService";
import { FimboApi } from "./services/FimboApiService";
import { GenreApi } from "./services/GenreApiService";
import { LessonApi } from "./services/LessonApiService";
import { LessonTypeApi } from "./services/LessonTypeApiService";
import { RecoverApi } from "./services/RecoverApiService";
import { SoulApi } from "./services/SoulOptionApiService";
import { VariableApi } from "./services/VariablesApiService";
import { lessonGeneratorAPI } from "./services/lessonGeneratorAPI";

const rootReducer = combineReducers({
  userReducer: userSlice.reducer,
  successMessageReducer: successSlice.reducer,
  warningMessageReducer: warningSlice.reducer,
  errorMessageReducer: errorSlice.reducer,
  hostReducer: hostSlice.reducer,
  [FimboApi.reducerPath]: FimboApi.reducer,
  [LessonApi.reducerPath]: LessonApi.reducer,
  [LessonTypeApi.reducerPath]: LessonTypeApi.reducer,
  [VariableApi.reducerPath]: VariableApi.reducer,
  [GenreApi.reducerPath]: GenreApi.reducer,
  [AudioApi.reducerPath]: AudioApi.reducer,
  [SoulApi.reducerPath]: SoulApi.reducer,
  [AnalyticApi.reducerPath]: AnalyticApi.reducer,
  [RecoverApi.reducerPath]: RecoverApi.reducer,
  [lessonGeneratorAPI.reducerPath]: lessonGeneratorAPI.reducer,
})

export const storeApp = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(FimboApi.middleware, LessonApi.middleware,
      LessonTypeApi.middleware, VariableApi.middleware, GenreApi.middleware, AudioApi.middleware,
      SoulApi.middleware, AnalyticApi.middleware, RecoverApi.middleware, lessonGeneratorAPI.middleware)
})

export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof storeApp.dispatch